import {
    OutstandingCashItem,
    TransactionForReconciliationFromStatement,
} from "@common/contracts/reconciliation.contract";
import { parseDateOnlyAsUTC } from "@common/helpers/date";
import { monetaryValuesEqual } from "@common/helpers/monetary";
import { canCashItemClearOnDate } from "@common/helpers/reconciliationCashItems";
import { TransactionListItem } from "@common/schemas/transaction.schema";
import { TransactionStatus, TransactionType } from "@common/types/transaction";

export interface StatementLineRow {
    row: TransactionListItem;
    line: TransactionForReconciliationFromStatement;
}

interface BuildStatementLineRowsParams {
    checkToMatch: Pick<OutstandingCashItem, "amount" | "date">;
    statementLines: TransactionForReconciliationFromStatement[];
    financialAccount: TransactionListItem["financialAccount"];
    entity: TransactionListItem["entity"];
    categoryId: string;
}

export function buildStatementLineRows({
    checkToMatch,
    statementLines,
    financialAccount,
    entity,
    categoryId,
}: BuildStatementLineRowsParams): StatementLineRow[] {
    return statementLines
        .filter(
            (line) =>
                monetaryValuesEqual(line.amount, checkToMatch.amount) &&
                canCashItemClearOnDate({
                    cashItemDateOnly: checkToMatch.date,
                    clearedDateOnly: line.date,
                }),
        )
        .map((line, index) => ({
            line,
            row: {
                id: -(index + 1),
                date: parseDateOnlyAsUTC(line.date),
                dateOnly: line.date,
                amountSaved: null,
                amount: line.amount,
                status: TransactionStatus.COMPLETED,
                counterpartyId: null,
                categoryId,
                isIgnored: false,
                isBusiness: entity.isBusiness,
                type: TransactionType.IMPORTED,
                requiredActions: [],
                requirementsSnoozed: false,
                potentialAmountSaved: null,
                bankDescription: line.bankDescription,
                originalAmount: line.amount,
                inReview: false,
                memo: null,
                displayDescription: null,
                deductionRate: 0,
                businessCategoryId: null,
                accountId: null,
                financialAccountId: financialAccount.id,
                financialAccount,
                entity,
            },
        }));
}
